import type { ApiStorageTransaction } from '@Model';
import { getStorageTransactionOrderReference, getStorageTransactionOriginLabel } from '@Model';
import { LinkOrder } from '@Modules/Billing';

interface IProps {
    booking: Pick<ApiStorageTransaction, 'origin_order' | 'origin_position' | 'origin_order_deleted'>;
}

/** "manuell", the order and position as a link, or as plain text with "(gelöscht)" when the order is deleted. */
// @ai-generated 2026-10-29T14:00:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function StorageTransactionOrigin({ booking }: IProps) {
    const reference = getStorageTransactionOrderReference(booking);
    if (reference === undefined || booking.origin_order_deleted) {
        return getStorageTransactionOriginLabel(booking);
    }
    return <LinkOrder order={{ ...booking.origin_order, display_string: reference, api_resource_name: 'orders' }} />;
}
